// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  margin: 0 0 5px;
  box-shadow: none;
  border: none;
  border-radius: 0;
  padding: 10px;
}
ion-card ion-label {
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 10px;
  display: block;
}
ion-card ion-card-content {
  background: var(--ons-color-primary-background);
  font-size: 14px;
  color: var(--ons-color-primary-black);
  font-family: var(--ons-font-medium);
}

.notes-header {
  color: var(--ons-color-primary-black);
  font-family: var(--ons-font-bold);
  font-size: 18px;
  margin-bottom: 10px;
}

.dashboard-block {
  background: white;
  border-radius: 4px;
  padding: 10px 20px;
  width: 100%;
  margin-bottom: 30px;
}
.dashboard-block.new {
  border: 1px solid var(--ons-color-primary);
  box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.05);
}
.dashboard-block .new-badge {
  position: absolute;
  top: 0;
  right: 0;
  padding: 3px 7px;
  border: 1px solid var(--ons-color-primary);
  border-top: 0px;
  border-right: 0px;
  font-size: 11px;
  border-bottom-left-radius: 6px;
  background: #fff;
  color: #000;
}

.today-title {
  color: var(--ons-color-grey);
  font-size: 12px;
  letter-spacing: -0.17px;
  font-family: var(--ons-font-medium);
  margin-bottom: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.today-title .edit-button {
  font-size: 20px;
  color: var(--ons-color-green);
  margin-left: 10px;
}

.new-data-badge {
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  margin-bottom: 15px;
  margin-top: 10px;
  padding: 5px 10px;
  border: 1px solid var(--ons-color-primary);
  border-radius: 5px;
  color: var(--ons-color-primary);
  font-size: 14px;
}

.show-on-dashboard {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.show-on-dashboard ion-label {
  font-size: 14px !important;
  margin-bottom: 0;
  font-weight: 500;
}
.show-on-dashboard ion-checkbox {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/notes-list/notes-list.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AACJ;AACI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AACR;AACI;EACI,+CAAA;EACA,eAAA;EACA,qCAAA;EAEA,mCAAA;AAAR;;AAIA;EACI,qCAAA;EACA,iCAAA;EACA,eAAA;EACA,mBAAA;AADJ;;AAIA;EACI,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AADJ;AAGI;EACI,0CAAA;EAEA,+CAAA;AADR;AAII;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,gBAAA;EACA,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;AAFR;;AAOA;EACI,4BAAA;EACA,eAAA;EACA,uBAAA;EACA,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAJJ;AAMI;EACI,eAAA;EACA,6BAAA;EACA,iBAAA;AAJR;;AAQA;EACI,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;AALJ;;AAQA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;AALJ;AAOI;EACI,0BAAA;EACA,gBAAA;EACA,gBAAA;AALR;AAQI;EACI,kBAAA;AANR","sourcesContent":["ion-card {\n    margin: 0 0 5px;\n    box-shadow: none;\n    border: none;\n    border-radius: 0;\n    padding: 10px;\n\n    ion-label {\n        font-weight: 600;\n        margin-top: 0;\n        margin-bottom: 10px;\n        display: block;\n    }\n    ion-card-content {\n        background: var(--ons-color-primary-background);\n        font-size: 14px;\n        color: var(--ons-color-primary-black);\n\n        font-family: var(--ons-font-medium);\n    }\n}\n\n.notes-header {\n    color: var(--ons-color-primary-black);\n    font-family: var(--ons-font-bold);\n    font-size: 18px;\n    margin-bottom: 10px;\n}\n\n.dashboard-block {\n    background: white;\n    border-radius: 4px;\n    padding: 10px 20px;\n    width: 100%;\n    margin-bottom: 30px;\n\n    &.new {\n        border: 1px solid var(--ons-color-primary);\n        -webkit-box-shadow: 0px 0px 2px 2px rgba(0,0,0,0.05); \n        box-shadow: 0px 0px 2px 2px rgba(0,0,0,0.05);\n    }\n\n    .new-badge {\n        position: absolute;\n        top: 0;\n        right: 0;\n        padding: 3px 7px;\n        border: 1px solid var(--ons-color-primary);\n        border-top: 0px;\n        border-right: 0px;\n        font-size: 11px;\n        border-bottom-left-radius: 6px;\n        background: #fff;\n        color: #000;\n    }\n    \n}\n\n.today-title {\n    color: var(--ons-color-grey);\n    font-size: 12px;\n    letter-spacing: -0.17px;\n    font-family: var(--ons-font-medium);\n    margin-bottom: 3px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .edit-button {\n        font-size: 20px;\n        color: var(--ons-color-green);\n        margin-left: 10px;\n    }\n}\n\n.new-data-badge {\n    display: flex;\n    width: fit-content;\n    margin-bottom: 15px;\n    margin-top: 10px;\n    padding: 5px 10px;\n    border: 1px solid var(--ons-color-primary);\n    border-radius: 5px;\n    color: var(--ons-color-primary);\n    font-size: 14px;\n}\n\n.show-on-dashboard {\n    margin-top: 10px;\n    display: flex;\n    align-items: center;\n\n    ion-label {\n        font-size: 14px !important;\n        margin-bottom: 0;\n        font-weight: 500;\n    }\n\n    ion-checkbox {\n        margin-right: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
